import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Activity, Map } from 'lucide-react';
export function MechanismSection() {
  const steps = [{
    number: '1',
    title: 'Higiene de cuenta',
    desc: 'Limpieza quirúrgica para reducir fricción sin autodestruir tu historial.',
    icon: ShieldCheck
  }, {
    number: '2',
    title: 'Ritmo seguro (7 días)',
    desc: 'Un plan diario para estabilizar sin movimientos de pánico.',
    icon: Activity
  }, {
    number: '3',
    title: 'Plan B',
    desc: 'Distribución e ingresos mientras se resuelve lo demás (para que no te secuestre la cabeza).',
    icon: Map
  }];
  return <section className="bg-[#0f0f0f] py-24" data-id="element-94">
      <div className="mx-auto max-w-6xl px-6" data-id="element-95">
        <div className="mb-16 text-center" data-id="element-96">
          <h2 className="text-3xl font-bold tracking-tight text-white md:text-4xl" data-id="element-97">
            La solución: 3 Capas de Control
          </h2>
          <p className="mt-4 text-gray-400" data-id="element-98">
            Este kit es un manual práctico (PDF) que te guía por un sistema
            simple:
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-3" data-id="element-99">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#1a1a1a] p-8 transition-colors hover:border-amber-500/30" data-id="element-100">
              <div className="absolute -right-4 -top-4 text-9xl font-black text-white/5" data-id="element-101">
                {step.number}
              </div>
              <step.icon className="mb-6 h-10 w-10 text-amber-500" data-id="element-102" />
              <h3 className="mb-3 text-xl font-bold text-white" data-id="element-103">
                {step.title}
              </h3>
              <p className="text-gray-400" data-id="element-104">{step.desc}</p>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-105">
          <p className="text-xl text-white" data-id="element-106">
            Y lo más importante:{' '}
            <span className="font-bold text-amber-500" data-id="element-107">no adivinas.</span>
          </p>
          <p className="mt-2 text-gray-400" data-id="element-108">
            Usas diagnóstico por síntomas + un árbol de decisiones.
          </p>
        </div>
      </div>
    </section>;
}